// src/api/auth.js
// eslint-disable-next-line import/no-cycle
import request from '@/lin/plugin/axios'

// 用户登录
export function login(data) {
  return request({
    url: '/v1/front/auth/login',
    method: 'post',
    data: {
      account: data.account, // 注意：后端接口使用的是account字段
      password: data.password
    }
  })
}

// 用户注册
export function register(data) {
  return request({
    url: '/v1/front/auth/register', // 请确认后端注册接口地址
    method: 'post',
    data: {
      username: data.username,
      password: data.password,
      confirm_password: data.confirmPassword,  // 注意：后端需要 confirm_password
      phone: data.phone,
      email: data.email,
      email_code: data.emailCode
    }
  })
}

// 用户注册发送验证码
export function sendEmailCode(email) {
  return request({
    url: '/v1/front/auth/send-email-code', // 请确认后端注册接口地址
    method: 'post',
    data: {
      email:email,
    }
  })
}

// 用户重置密码发送验证码
export function sendForgotPasswordCode(data) {
  return request({
    url: '/v1/front/auth/forgot-password/send-code',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/v1/front/auth/forgot-password/reset',
    method: 'post',
    data
  })
}

// 用户退出登录
export function logout() {
  return request({
    url: '/v1/front/auth/logout', // 请确认后端退出接口地址
    method: 'post'
  })
}

// 获取当前用户信息
export function getCurrentUser() {
  return request({
    url: '/v1/front/auth/me', // 请确认后端获取用户信息接口地址
    method: 'get'
  })
}

// 刷新token（如果需要）
export function refreshToken() {
  return request({
    url: '/v1/front/auth/refresh', // 请确认后端刷新token接口地址
    method: 'post'
  })
}
